import React, { useState } from 'react';
import {useNavigate} from "react-router-dom";
import { Box, Input, Stack, InputGroup, InputRightElement, Icon, useToast } from "@chakra-ui/react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './AdminLogin.css';
import logo from '../../assets/logos/newlogonobg.png';
import axios from "axios";


const AdminLogin = () => {
  const navigate= useNavigate();
  const toast= useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [userName, setUserName]= useState("");
  const [password, setPassword]= useState("");
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleAuth= async(e)=>{
    e.preventDefault();
    try{
        const body= {
          "user": userName,
          "pass": password
        }
        const response= await axios.post("https://leatherandstyle.netlify.app/.netlify/functions/adminLogin", body);
        if(response.status==200){

          toast({
            title: "Login Successfull",
            description: "Welcome to Admin Dashboard",
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          })
          navigate("/LSESPM@467adminPage");
        }else{
          toast({
            title: "Invalid Credentials",
            description: "Please try again",
            status:"error",
            duration: 3000,
            isClosable: true,
            position:"top-right"
          })
        } 

    }catch(e){
      console.log("error in authenticating the admin");
      toast({
        title: "Error in Authenticating Admin",
        description: "Please try again",
        status:"error",
        duration: 3000,
        isClosable: true,
        position:"top-right"
      })
    }
  }

  return (
    <div className='main-admin-login-container'>
      <Box bg="bg" className='admin-title'>
        <img src={logo} alt="Logo" className="admin-logo" />
        <span className='admin-title-text'>Leather and Style</span>
      </Box>
      <Box bg="bg" shadow="md" borderRadius="md" className='admin-login-box'>
        <span className='admin-login-box-header'>Admin Login</span>
        <form>
        <Stack className='admin-login-inputs' >
          <Input placeholder="Username"  value={userName} onChange={(e)=>{setUserName(e.target.value)}}/>
          <InputGroup>
            <Input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={password} onChange={(e)=>{setPassword(e.target.value)}}
            />
            <InputRightElement width="3rem">
              <Icon
                as={showPassword ? FaEyeSlash : FaEye}
                onClick={togglePasswordVisibility}
                cursor="pointer"
                color="gray.500"

              />
            </InputRightElement>
          </InputGroup>
        </Stack>
        <button className='admin-login-submit' onClick={handleAuth}>
          Login
        </button>
        </form>
      </Box>
      
    </div>
  );
}

export default AdminLogin;
